import { useEffect } from "react";
import { generateStaticPieNode } from "../../graph-util";
import { extractRhaPieChunks } from "../../utils";

import { CreateControlNodeOnlyFn, Rha1Counters } from "../../@types";

interface Props {
  renderer: CreateControlNodeOnlyFn;
  counts: { pie: Rha1Counters | undefined };
}

const useRenderRha1SimilarityRS = ({
  renderer: createControlNodeFromData,
  counts: { pie: rhaCounters }
}: Props) => {
  useEffect(() => {
    if (!rhaCounters || rhaCounters?.total < 1) return;
    createControlNodeFromData({
      generateControlNode: () =>
        generateStaticPieNode({
          id: "rha1SimilarityNode",
          label: `RHA Similarity`,
          radius: 70,
          ...extractRhaPieChunks(rhaCounters)
        })
    });
  }, [createControlNodeFromData, rhaCounters]);
};

export default useRenderRha1SimilarityRS;
